import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, tokenStore } from "@/lib/api";
import { useAuth, AUTH_URL, SAFE_NEXT, roleHome } from "@/context/AuthContext";

export default function AuthCallback() {
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const p = new URLSearchParams(window.location.hash.slice(1));
    window.history.replaceState(null, "", "/auth/callback");
    const next = p.get("next") || "";
    (async () => {
      try {
        const { data } = await api.post("/auth/handoff/redeem", { code: p.get("code") || "" });
        tokenStore.set(data);
        const u = await checkAuth();
        if (!u) throw new Error("auth");
        navigate(SAFE_NEXT.test(next) ? next : roleHome(u), { replace: true });
      } catch {
        setFailed(true);
      }
    })();
  }, [checkAuth, navigate]);

  if (failed) {
    return (
      <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-4 bg-white text-[#0A234A]" data-testid="auth-callback-failed">
        <p className="text-sm font-semibold">Your sign-in link expired.</p>
        <a href={`${AUTH_URL}/login`} data-testid="auth-callback-retry" className="rounded-xl bg-[#FF5722] px-4 py-2 text-sm font-bold text-white hover:bg-[#F4511E]">Sign in again</a>
      </div>
    );
  }
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-white" data-testid="auth-callback-loader">
      <span className="h-6 w-6 animate-spin rounded-full border-2 border-[#FF5722]/25 border-t-[#FF5722]" />
    </div>
  );
}
